import { Box } from '@material-ui/core';
import { getInvites } from 'APIs/UserDataApi';
import { useAppSelector } from 'app/hooks';
import { NormalButton } from 'components/atoms/Button';
import Loader from 'components/atoms/loader';
import { selectAuth } from 'features/auth/authSlice';
import React, { useEffect, useState } from 'react';
import { v4 } from 'uuid';
import {
  Container,
  InviteItem,
  InviteList,
  MainBody,
  SmallText,
  SubTitleText,
  TitleText,
} from './inviteCreatorPage.styles';

const InviteCreatorPage = (props: any) => {
  const [hasCopied, setHasCopied] = useState<boolean>(false);
  const [copiedIndex, setCopiedIndex] = useState<number | null>(null);
  const authState = useAppSelector(selectAuth);
  const [invites, setInvites] = useState<string[]>([]);
  const [usedInvites, setUsedInvites] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const rootUrl = window.location.href.split('/i')[0];

  useEffect(() => {
    setLoading(true);
    const fetchInvites = async () => {
      if (authState.username) {
        const res = await getInvites(authState.username);
        setInvites(res.data);
        setUsedInvites(new Array(3 - res.data.length).fill(v4()));
        setLoading(false);
      }
    };
    fetchInvites();
  }, [authState.username]);

  function handleCopyToClip(text: string, i: number): void {
    navigator.clipboard.writeText(text);
    setHasCopied(true);
    setCopiedIndex(i);
    setTimeout(() => {
      setCopiedIndex(null);
      setHasCopied(false);
    }, 2000);
  }

  return (
    <MainBody>
      <Container>
        <TitleText style={{ textAlign: 'center' }}>Invite Creator</TitleText>

        <SubTitleText style={{ textAlign: 'center' }}>
          Copy an invite URL and share it with a creator to give them access to
          creator mode.
        </SubTitleText>

        <SubTitleText
          style={{ textAlign: 'right', padding: '0px 10px', color: '#9b9b9b' }}
        >
          {invites.length}/3 Invites Available
        </SubTitleText>

        {loading ? (
          <Loader sx={{ marginTop: '100px' }} />
        ) : (
          <InviteList>
            {invites.map((invite, i) => (
              <InviteItem key={i}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                  }}
                >
                  <SmallText style={{ marginBottom: '8px' }}>
                    <strong>Invite Url</strong>
                  </SmallText>
                  <SmallText>
                    {rootUrl}?token={invite}
                  </SmallText>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                  }}
                >
                  <NormalButton
                    onClick={() =>
                      handleCopyToClip(`${rootUrl}?token=${invite}`, i)
                    }
                  >
                    {hasCopied && copiedIndex === i
                      ? 'Copied to clipboard'
                      : 'Copy Invite URL'}
                  </NormalButton>
                </Box>
              </InviteItem>
            ))}
            {usedInvites.map((item, index) => (
              <InviteItem
                key={index}
                style={{
                  backgroundColor: 'rgba(255,255,255, 0.1)',
                  boxShadow: 'none',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                  }}
                >
                  <SmallText style={{ marginBottom: '8px' }}>
                    <strong>Invite Url</strong>
                  </SmallText>
                  <SmallText>{`${rootUrl}?token=${
                    invites[0] || v4()
                  }`}</SmallText>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                  }}
                >
                  <NormalButton isDisabled={true}>Claimed</NormalButton>
                </Box>
              </InviteItem>
            ))}
          </InviteList>
        )}
      </Container>
    </MainBody>
  );
};

export default InviteCreatorPage;
